module.exports = __webpack_public_path__ + "img/alex-tampi-login.38a8509c.png";